import { render, staticRenderFns } from "./RootCause.vue?vue&type=template&id=3ad6784e&scoped=true"
import script from "./RootCause.vue?vue&type=script&lang=js"
export * from "./RootCause.vue?vue&type=script&lang=js"
import style0 from "./RootCause.vue?vue&type=style&index=0&id=3ad6784e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad6784e",
  null
  
)

export default component.exports